export default "__VITE_ASSET__BecBimSm__"